import { render, staticRenderFns } from "./SearchInvestmentFund.vue?vue&type=template&id=fe4754c4&scoped=true"
import script from "./SearchInvestmentFund.vue?vue&type=script&lang=js"
export * from "./SearchInvestmentFund.vue?vue&type=script&lang=js"
import style1 from "./SearchInvestmentFund.vue?vue&type=style&index=1&id=fe4754c4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4754c4",
  null
  
)

export default component.exports